import { ExternalLink } from "lucide-react";

/**
 * 2x2 grid of promotional banners for location pages.
 * Shows up to 4 active promotions at once for at-a-glance visibility.
 * Used ONLY on location browse pages, not the public main site.
 */
export default function PromoGrid({ promotions }) {
  if (!promotions || promotions.length === 0) return null;

  // Take up to 4 promotions
  const visible = promotions.slice(0, 4);

  const handleClick = (promo) => {
    if (promo.link_url) window.open(promo.link_url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="mb-6 grid grid-cols-2 gap-2 sm:gap-3" data-testid="promo-grid">
      {visible.map((promo) => {
        const clickable = !!promo.link_url;
        return (
          <button
            key={promo.id}
            type="button"
            onClick={() => handleClick(promo)}
            disabled={!clickable}
            className={`relative h-28 sm:h-36 rounded-xl overflow-hidden text-left transition-transform ${
              clickable ? "hover:scale-[1.02] cursor-pointer" : "cursor-default"
            }`}
            data-testid={`promo-grid-${promo.id}`}
          >
            {/* Background */}
            {promo.image_base64 ? (
              <img
                src={promo.image_base64}
                alt={promo.title}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            ) : (
              <div className="absolute inset-0 bg-gradient-to-br from-[#1aa59a] to-[#158a80]" />
            )}

            {/* Dark overlay for legibility */}
            {(promo.title || promo.subtitle) && (
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
            )}

            {/* Text */}
            <div className="absolute inset-0 p-2 sm:p-3 flex flex-col justify-end text-white">
              {promo.title && (
                <h3 className="text-sm sm:text-base font-bold leading-tight line-clamp-2">
                  {promo.title}
                </h3>
              )}
              {promo.subtitle && (
                <p className="text-xs opacity-90 mt-0.5 line-clamp-1">{promo.subtitle}</p>
              )}
            </div>

            {/* External link indicator */}
            {clickable && (
              <div className="absolute top-1.5 right-1.5 sm:top-2 sm:right-2 bg-white/20 backdrop-blur-sm rounded-full p-1">
                <ExternalLink className="w-3 h-3 text-white" />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
